module.exports = __webpack_public_path__ + "assets/img/8a0535d105a26b713722db102568e123.png";